import { Grid } from '@material-ui/core';
import React from 'react';
import ModalCard from 'shared-assets/components/Modal/ModalCard';
import { Alert, Button, Typography } from '@kareo/design-system';
import { EXPORT_IMMUNIZATION_INFO, MoreMenuTitles, } from 'shared-assets/facesheet-ui/service/legacy/types';
var ExportModalCard = function (_a) {
    var headerTitle = _a.headerTitle, isOpen = _a.isOpen, onClose = _a.onClose, exportData = _a.exportData;
    var getFileFormat = function () {
        var fileFormatText = 'HL7';
        if (headerTitle === MoreMenuTitles.Referral ||
            headerTitle === MoreMenuTitles.Continuity) {
            fileFormatText = 'XML';
        }
        return fileFormatText;
    };
    return (React.createElement(ModalCard, { open: isOpen, onClose: onClose, header: React.createElement(Typography, { variant: "h2", component: "div" }, headerTitle), footer: React.createElement(Grid, { container: true, direction: "row-reverse" },
            React.createElement(Grid, { item: true },
                React.createElement(Button, { color: "vitality", onClick: exportData }, "Export")),
            React.createElement(Grid, { item: true },
                React.createElement(Button, { color: "vitality", variant: "text", onClick: onClose }, "Cancel"))) },
        React.createElement(Alert, { severity: "warning" }, "You will be prompted to save the exported file locally on your computer. Please make sure only authorized staff have access to the location where you are storing the file."),
        headerTitle === MoreMenuTitles.Immunization && (React.createElement(Typography, null, EXPORT_IMMUNIZATION_INFO)),
        React.createElement(Typography, { variant: "body1", color: "error" },
            "The exported file will be ",
            getFileFormat(),
            " format, which is not human readable")));
};
export default ExportModalCard;
